// extracted by mini-css-extract-plugin
module.exports = {"block":"SpeakersOnMain_block___N4gb","wrapper":"SpeakersOnMain_wrapper__wanoY","container":"SpeakersOnMain_container__l872k","card":"SpeakersOnMain_card__eGFgx"};